import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import PostsList from "./PostList";
import AkkhorLayout from "../layout/akkhor";
import { useParams } from "react-router-dom";
import Calendar from "./Calendar";
import { checkRole } from "../model";
import { Modal } from "react-bootstrap";
import Axios from "axios";
import Spinner from "../component/Spinner";
import AppShortcut from "./AppShortcut";

export default function BangTin() {
  const { user } = useSelector((state) => state.auth);
  const { alias } = useParams();
  const info = user && user.data ? user.data : null;
  const [listnews, setListNews] = useState(null)
  const [listGroup, setListGroup] = useState([]);
  const [baocaoblue, setBaocaoblue] = useState([])
  const [modalCalendar, setModalCalendar] = useState(false);
  const [modalGroup, setModalGroup] = useState(false);
  const [groupInfo, setGroupInfo] = useState(null);
  const [groupLoading, setGroupLoading] = useState(false);

  const addGroup = async () => {
    if (!groupInfo?.title) {
      return alert("Vui lòng nhập tên danh mục");
    }
    setGroupLoading(true);
    const method = groupInfo.id ? Axios.put : Axios.post;
    try {
      const { data } = await method(`${URL_LIST_ALL}post_group`, groupInfo, user.config);
      if (data.status === "success") {
        window.location.reload();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setGroupLoading(false);
    }
  };

  useEffect(() => {
    if (!modalGroup) setGroupInfo(null);
  }, [modalGroup]);

  useEffect(() => {
    axios.get(URL_LIST_ALL + "news?limit=10000&forusers=" + user.data.code, user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setListNews(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  useEffect(() => {
    axios.get(URL_LIST_ALL + "post_group?limit=10000", user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setListGroup(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  useEffect(() => {
    axios.get(URL_LIST_ALL + "baocaoblue?limit=10", user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setBaocaoblue(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  return (
    <AkkhorLayout idrole="dashboard" class_name="col-12 home-dashboad home-dashboard-content">
      {info &&
        <div className="container-fluid p-0 form-info">
          <div className="col-left">
            <div className="wrapper">
              <div className="box-content box-post-group shadow p-2 rounded">
                <div className="w-100 d-flex justify-content-center list-post-group mb-1">
                  <div className="list-post-container">
                    <a href="/bang-tin" className={`btn btn-sm mb-1 mr-1 ${!alias ? "btn-primary" : "btn-outline-primary"}`}>#Tất cả</a>
                    {listGroup?.map((gr) => (
                      <a
                        href={`/bang-tin/danh-muc/${gr.alias}`}
                        key={gr.id}
                        className={`btn btn-sm mb-1 mr-1 ${alias === gr.alias ? "btn-primary" : "btn-outline-primary"}`}
                      >
                        #{gr.title}
                      </a>
                    ))}

                    {checkRole(user, "post_group", "") && (
                      <button type="button" className="btn btn-sm btn-outline-success mb-1 mr-1" onClick={() => setModalGroup(true)}>
                        <i className="fas fa-plus"></i>
                      </button>
                    )}

                    <button href="#" className="btn btn-sm btn-outline-primary d-inline-block d-sm-none mb-1" type="button" onClick={() => setModalCalendar(true)}>
                      <i className="far fa-calendar-alt"></i>
                    </button>
                  </div>
                  <Modal show={modalCalendar} className="modal-thread" onHide={() => setModalCalendar(false)} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title>Lịch sự kiện </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Calendar />
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
              <div className="box-content d-none d-sm-block shadow p-3 mt-3 rounded">
                <h5 className="w-100 text-center mb-3">Lối tắt</h5>
                <div className="w-100 app-shortcut">
                  <AppShortcut />
                </div>
              </div>
              <div className="box-content d-none d-sm-block shadow p-3 mt-3 rounded">
                <Calendar />
              </div>
            </div>
          </div>
          <div className="list-post-content">
            <PostsList alias={alias} listGroup={listGroup} />
          </div>
          <div className="right-sidebar">
            <div className="box-content shadow p-3 rounded">
              <div className="w-100 baocaoblue">
                <h5 className="text-center">Top tương tác tháng</h5>
                <div className="w-100 d-flex justify-content-center mt-2">
                  <div className="calendar-container">
                    <table className="table table-striped table-bordered table-hover font-13">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Họ tên</th>
                          <th>Like</th>
                          <th>Comment</th>
                          <th>Tổng</th>
                        </tr>
                      </thead>
                      <tbody>
                        {baocaoblue && baocaoblue.map((item, i) => {
                          return <tr key={item.id}>
                            <td className="text-center">{i + 1}</td>
                            <td>{item.fullname}</td>
                            <td className="text-center">{item.total_likes}</td>
                            <td className="text-center">{item.total_comments}</td>
                            <td className="text-center">{item.total_interactions}</td>
                          </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="box-content shadow mt-3 p-3 rounded">
              <h5 className="w-100 text-center">Quy trình nội bộ</h5>
              <ul className="dashboard-list-new">
                {listnews && listnews.map((item, i) => {
                  return (
                    <li key={i}>
                      <a href={"/quy-trinh-noi-bo/" + item.id}><i className="	fas fa-angle-double-right"></i> {item.title}</a>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      }
      {/* Modal thêm danh mục */}
      <Modal show={modalGroup} className="modal-thread" onHide={() => setModalGroup(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Thêm danh mục Cộng đồng</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 form-group">
            <label>Tên danh mục <span className="text-danger">*</span></label>
            <input
              type="text"
              placeholder="VD: Nội bộ BHS"
              className="form-control height32"
              value={groupInfo?.title || ""}
              onChange={(e) => setGroupInfo({ ...groupInfo, title: e.target.value })}
              autoComplete="off"
            />
          </div>
          <div className="col-12 form-group">
            <button type="button" className="btn btn-sm btn-success" onClick={addGroup} disabled={groupLoading}>
              {groupLoading ? <Spinner /> : "Lưu danh mục"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </AkkhorLayout>)
}